<ul class="pagination">
  <li *ngFor="let page of pages" class="page-item" [ngClass]="{ active: currentPage === page }">
    <a [routerLink]="[url]" class="page-link" [queryParams]="{ page: page }">
      {{ page }}
    </a>
  </li>
</ul>
